// 发布模式
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
// 引入全局样式
import './assets/css/global.less'


// // 按需引入element
import './plugins/element.js'

// vueX
import store from './store'
// 富文本
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)

// 打印
import Print from 'vue-print-nb'
//注册为了指令
Vue.use(Print);

// 在线签名
import SignCanvas from 'sign-canvas';
Vue.use(SignCanvas);

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

// import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'
// Vue.use(Viewer)

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
// 全局loading-enelemtn
import { Message, Loading } from 'element-ui' //项目已经全局引入element的话可以不单独引入
let loading = null //定义loading变量
//开始 加载loading
let startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(255, 255, 255, .6)'
  })
}
//结束 取消loading加载
let endLoading = () => {
  loading.close()
}
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
};
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
};


// 测试地址
 //var basURLStr = 'https://control.sxpz.vip/index.php/AppApi/'
var basURLStr = 'https://test.control.sxpz.vip/index.php/AppApi/'
//Vue.prototype.basURLStr = 'https://control.sxpz.vip'
Vue.prototype.basURLStr = 'https://test.control.sxpz.vip'


var instance = axios.create()
if (process.env.NODE_ENV == 'development') {
  instance.defaults.baseURL == process.env.VUE_APP_BASEURL
} else if (process.env.NODE_ENV == 'production') {
  instance.defaults.baseURL == basURLStr
}
instance.interceptors.request.use(function (config) {
  if (process.env.NODE_ENV == 'production') {
    config.url = basURLStr + config.url.split(/\/api\//)[1]
  }
  // startLoading()
  showFullScreenLoading()
  return config
})
// 响应拦截器
// instance.interceptors.response.use(config => {
//   return config;
// })
instance.interceptors.response.use(
  response => {
    //拦截响应，做统一处理 
    if (response.data.code) {
      switch (response.data.code) {

        case 100:
          // 用户id
          window.localStorage.removeItem('btlh_process_member_id')
          // 用户邮箱
          window.localStorage.removeItem('btlh_process_mail')
          // 用户昵称
          window.localStorage.removeItem('btlh_process_nickname')
          // token
          window.localStorage.removeItem('btlh_process_token')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
      }
    }
    // endLoading()
    tryHideFullScreenLoading()
    return response
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    // endLoading()
    tryHideFullScreenLoading()
    return Promise.reject(error.response.status) // 返回接口返回的错误信息
  })
var instance1 = axios.create()
var instance1 = axios.create()
if (process.env.NODE_ENV == 'development') {
  instance1.defaults.baseURL == process.env.VUE_APP_BASEURL
} else if (process.env.NODE_ENV == 'production') {
  instance1.defaults.baseURL == basURLStr
}
instance1.interceptors.request.use(function (config) {
  if (process.env.NODE_ENV == 'production') {
    config.url = basURLStr + config.url.split(/\/api\//)[1]
  }


  // let timer = setTimeout(function () {
  // }, 300)
  // timers.push(timer)
  // console.log('timer', timer)
  return config
})
// 响应拦截器
// instance1.interceptors.response.use(config => {
//   return config;
// })
instance1.interceptors.response.use(
  response => {
    //拦截响应，做统一处理 
    if (response.data.code) {
      switch (response.data.code) {
        case 100:
          // 用户id
          window.localStorage.removeItem('btlh_process_member_id')
          // 用户邮箱
          window.localStorage.removeItem('btlh_process_mail')
          // 用户昵称
          window.localStorage.removeItem('btlh_process_nickname')
          // token
          window.localStorage.removeItem('btlh_process_token')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
      }
    }
    // timers = []
    return response
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    // timers.forEach(item => {
    //   console.log('clear', item)
    //   clearTimeout(item)
    // })
    // timers = []
    return Promise.reject(error.response.status) // 返回接口返回的错误信息
  })

// instance2全地址 不带/api
var instance2 = axios.create()
instance2.interceptors.response.use(
  response => {
    //拦截响应，做统一处理 
    if (response.data.code) {
      switch (response.data.code) {
        case 100:
          // 用户id
          window.localStorage.removeItem('btlh_process_member_id')
          // 用户邮箱
          window.localStorage.removeItem('btlh_process_mail')
          // 用户昵称
          window.localStorage.removeItem('btlh_process_nickname')
          // token
          window.localStorage.removeItem('btlh_process_token')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
      }
    }
    return response
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    return Promise.reject(error.response.status) // 返回接口返回的错误信息
  })
Vue.prototype.$axios = instance
Vue.prototype.$http = instance1
Vue.prototype.$https = instance2
Vue.config.productionTip = false
Vue.prototype.$startLoading = startLoading
Vue.prototype.$endLoading = endLoading

// 解决路由catch报错
// import VueRouter from 'vue-router'
// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }
// 解决路由catch报错

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
